/** Halaman pendaftaran pemohon awam (pelan F3), iaitu `planning.register`, yang turut memegang kunci sepanduk daftar peta 1A. */
export default {
  // The case page's map-register banner (1A) shares this root.
  pending: 'Kemas kini peta belum selesai.',
  dead: 'Kemas kini peta gagal.',
  lastError: 'Ralat terakhir: {{error}}',
  retry: 'Cuba kemas kini peta semula',
  retried: 'Kemas kini peta telah digilirkan semula.',
  // Plan P4-1a D-411: "may", because the public form cannot read whether the tenant turned notifications on.
  emailNotice:
    'Majlis mungkin menghantar kemas kini tentang permohonan anda melalui e-mel. Anda boleh mematikannya di Keutamaan e-mel selepas log masuk.',
  shell: {
    language: 'Bahasa',
    fallbackName: 'Kebenaran Merancang',
  },
  form: {
    title: 'Daftar sebagai pemohon',
    intro:
      'Perunding mengemukakan permohonan kebenaran merancang secara dalam talian. Hantar butiran anda: pegawai akan menyemaknya, dan anda akan menerima butiran log masuk melalui e-mel setelah diluluskan.',
    email: 'E-mel',
    displayName: 'Nama penuh',
    firm: 'Firma (pilihan)',
    regNo: 'Nombor pendaftaran profesional (pilihan)',
    submit: 'Hantar pendaftaran',
    required: 'Wajib diisi.',
    emailInvalid: 'Masukkan alamat e-mel yang sah.',
    tooLong: 'Terlalu panjang: maksimum {{max}} aksara.',
    haveCode: 'Sudah mendaftar? Semak status anda',
    signIn: 'Sudah mempunyai akaun? Log masuk',
  },
  accepted: {
    title: 'Pendaftaran diterima',
    body: 'Jika butiran anda boleh diterima, pegawai akan menyemak permohonan anda. Anda akan menerima butiran log masuk melalui e-mel setelah ia diluluskan.',
    codeLabel: 'Kod status anda',
    codeHint:
      'Simpan kod ini: ia satu-satunya cara untuk menyemak status pendaftaran anda, dan ia tidak dipaparkan lagi selepas anda meninggalkan halaman ini.',
    copy: 'Salin kod',
    copied: 'Disalin',
  },
  status: {
    title: 'Status pendaftaran',
    intro: 'Tampal kod status yang anda terima semasa mendaftar.',
    codeLabel: 'Kod status',
    check: 'Semak status',
    submittedAt: 'Dimohon pada {{date}}',
    reason: 'Sebab: {{reason}}',
    states: {
      submitted: 'Menunggu semakan',
      approved: 'Diluluskan. Semak e-mel anda untuk butiran log masuk.',
      rejected: 'Tidak diluluskan',
      superseded: 'Digantikan oleh pendaftaran yang lebih baharu dengan e-mel yang sama',
      expired: 'Tamat tempoh tanpa keputusan. Anda boleh mendaftar semula.',
    },
    notFound: 'Tiada pendaftaran yang sepadan dengan kod ini. Pastikan anda menampal keseluruhannya.',
    registerAgain: 'Daftar semula',
  },
  errors: {
    closed: 'Pendaftaran pemohon tidak dibuka untuk organisasi ini.',
    rateLimited: 'Terlalu banyak cubaan dari sambungan anda. Tunggu beberapa minit dan cuba lagi.',
    invalid: 'Sesetengah butiran tidak sah. Semak medan yang ditandakan.',
    network: 'Tidak dapat menghubungi pelayan. Semak sambungan anda dan cuba lagi.',
    generic: 'Sesuatu tidak kena. Cuba lagi.',
  },
} as const
